
import * as React from "react";
import { connect } from "react-redux";
import { Alert } from "../presentational/widgets/AlertBar";
import { getAlertsViaApi } from '../actions/AlertActions';
import { AlertService } from "../services/AlertService";

export interface AlertContainerProps { 
  showSystemAlerts : boolean;
  alerts: any;
  getAlertsViaApi: any;
  userId: string;
}

export interface AlertContainerState {
    
}

const mapStateToProps = (state : any) => {
  return {
    alerts : state.alerts,
    userId: state.user.userId
  };
};


const mapDispatchToProps = (dispatch : any) => {
  return {
    getAlertsViaApi: (url: string, userId: string) => {
        dispatch(getAlertsViaApi(url, userId));
    }
  };
};


 class AlertWrapper extends React.Component<AlertContainerProps, AlertContainerState> {
  constructor(props : AlertContainerProps) {
    super(props);

    this.state = {
    };

  }

  componentDidMount() {
    if (this.props.showSystemAlerts) {
      this.props.getAlertsViaApi(AlertService.getApiUrl(), this.props.userId);
    }
  }

  render() {
    return <Alert alerts={this.props.alerts.alerts}></Alert>;
  }
}

export const AlertContainer = connect(mapStateToProps, mapDispatchToProps)(AlertWrapper);